import React, { Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { CookieConsentProvider, CookieConsentModal, } from '@xingternal/cookie-consent';
import { XingFrameProvider, XingFrameConsumer, } from '@xingternal/frame-data-provider';
import styles from './XingFrameProvider.css';
export const XingFrame = ({ type, children, userConsentSettings, ...props }) => {
    return (React.createElement(XingFrameProvider, { ...{
            type,
            internalPaths: [],
        }, ...props },
        React.createElement(XingFrameConsumer, null, ({ isOmViewVisible, omViewRef, omViewAnimationDuration }) => {
            return (React.createElement(Fragment, null,
                React.createElement(CSSTransition, { in: isOmViewVisible, classNames: {
                        enter: styles.omViewEnter,
                        enterActive: styles.omViewEnterActive,
                        enterDone: styles.omViewEnterDone,
                        exit: styles.omViewExit,
                        exitActive: styles.omViewExitActive,
                        exitDone: styles.omViewExitDone,
                    }, timeout: omViewAnimationDuration },
                    React.createElement("div", { className: classNames(styles.omView, {}), ref: omViewRef })),
                React.createElement(CSSTransition, { in: !isOmViewVisible, classNames: {
                        enter: styles.contentEnter,
                        enterActive: styles.contentEnterActive,
                        enterDone: styles.contentEnterDone,
                        exit: styles.contentExit,
                        exitActive: styles.contentExitActive,
                        exitDone: styles.contentExitDone,
                    }, timeout: omViewAnimationDuration },
                    React.createElement("div", null,
                        React.createElement(CookieConsentProvider, null,
                            React.createElement(CookieConsentModal, { ...userConsentSettings }),
                            children)))));
        })));
};
//# sourceMappingURL=XingFrameProvider.js.map